import {
    specificCountryUrl,
    specificCountryUrlData,
} from "../../../public/Constants/EnumConstants";

export const ARROW_CLASS =
    "transition-all delay-50 duration-300 w-auto h-auto ";
export const ARROW_ROTATE = " rotate-180 ";

// Utility function or inside the component
export const getPathSpecificCountryData = (pathname) => {
    const matchedKey = Object.keys(specificCountryUrl).find(
        (key) => specificCountryUrl[key] === pathname
    );

    return matchedKey ? specificCountryUrlData[matchedKey] : null;
};
